<!--

	This component replaces the deprecated `v-promise-btn`, showing a Vuetify loading indicator 
	while a provided promise is pending. The loader hides when the promise resolves or rejects.

	It watches the `promise` prop to automatically manage the loading state, offering more 
	flexibility than `v-promise-btn` by tracking asynchronous operations directly via the promise.

-->
<template>
	<div class="mia-PromiseLoader" :class="{ 'mia-PromiseLoader--loading': loading }">
		<v-progress-circular v-if="loading" v-bind="progressCircularOptions" indeterminate />
		<slot></slot>
	</div>
</template>
<script lang="ts">
import { VProgressCircular } from 'vuetify/components'

export default {
	name: 'PromiseLoader',

	props: {
		promise: {
			type: [Promise, null],
			required: true
		},
		progressCircularOptions: {
			type: Object,
			required: false,
			default: {
				size: 16,
				width: 2
			}
		}
	},

	components: {
		VProgressCircular
	},

	data() {
		return {
			loading: false
		}
	},

	watch: {
		promise: {
			async handler(currentPromise) {
				this.loading = true;
				try {
					if(currentPromise) {
						await currentPromise;
					}
				} finally {
					if(currentPromise !== this.promise) {
						return;
					}
					this.loading = false;
				}
			},
			immediate: true
		}
	}
}
</script>
<style lang="scss">
.mia-PromiseLoader {
	display: flex;

	&.mia-PromiseLoader--loading {
		.mia-Icon {
			display: none;
		}
	}
}
</style>
